// Toast — minimal Snackbar wrapper hook for module pages.
// Replaces ad-hoc `Snackbar` boilerplate per page.

import { useState, useCallback } from "react";
import { Alert, Snackbar } from "@mui/material";

export type ToastSeverity = "success" | "info" | "warning" | "error";

export interface ToastState {
  open: boolean;
  message: string;
  severity: ToastSeverity;
}

export function useToast() {
  const [state, setState] = useState<ToastState>({
    open: false,
    message: "",
    severity: "info",
  });

  const show = useCallback(
    (message: string, severity: ToastSeverity = "info") => {
      setState({ open: true, message, severity });
    },
    [],
  );

  const close = useCallback(() => {
    setState((s) => ({ ...s, open: false }));
  }, []);

  const ToastEl = (
    <Snackbar
      open={state.open}
      autoHideDuration={5000}
      onClose={close}
      anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
    >
      <Alert severity={state.severity} variant="filled" onClose={close}>
        {state.message}
      </Alert>
    </Snackbar>
  );

  return { show, close, ToastEl } as const;
}
